module.exports = __webpack_public_path__ + "img/play.9d0e5753.svg";